// 客户端-侧边栏-课程快捷键
export default {
  methods: {
    // 本地存储当前页面信息
    localSavePage(data) {
      const courseId = data.id || data.course_id;
      if (window.isElectron) {
        try {
          const key = "course_" + this.user.user_id;
          let localData = JSON.parse(localStorage.getItem(key) || "[]");
          if (localData && Array.isArray(localData)) {
            // 判断课程id
            const isHave = localData.some(
              (item) => item.courseInfo && item.courseInfo.id === courseId
            );
            if (!isHave) {
              // 不存在
              if (localData.length >= 10) {
                //取前九个
                localData = localData.splice(0, 9);
              }
              const obj = {
                path: this.$route.fullPath,
                courseInfo: {
                  ...data,
                  id: courseId,
                },
                course_id: courseId,
                timeStamp: new Date().getTime(),
              };
              // 前增
              localData.unshift(obj);
              localStorage.setItem(key, JSON.stringify(localData));
              const event = new CustomEvent("local-storage-changed", {
                detail: { key: key, newValue: localData },
              });
              window.dispatchEvent(event);
            }
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
  },
};
